import React, { createContext, useContext, useState, useEffect } from 'react'

const LanguageContext = createContext()

export const LanguageProvider = ({ children }) => {
  const [lang, setLang] = useState('EL') // default language

  useEffect(() => {
    // Access localStorage only in browser
    const storedLang = localStorage.getItem('preferredLang')
    if (storedLang) setLang(storedLang)
  }, [])

  const switchLanguage = (newLang) => {
    setLang(newLang)
    if (typeof window !== 'undefined') {
      localStorage.setItem('preferredLang', newLang)
    }
  }

  return (
    <LanguageContext.Provider value={{ lang, switchLanguage }}>{children}</LanguageContext.Provider>
  )
}

export const useLanguage = () => {
  const context = useContext(LanguageContext)
  if (!context) {
    // Fallback for SSR rendering
    return { lang: 'EL', switchLanguage: () => {} }
  }
  return context
}
